import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e905c96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userinfo-box" }
const _hoisted_2 = { style: {"color":"red"} }
const _hoisted_3 = {
  key: 0,
  class: "button-wrap-box"
}
const _hoisted_4 = { class: "table-add-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_6 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ActiveityItem = _resolveComponent("ActiveityItem")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "vip-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        ref: "form",
        "label-position": "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "普通会员" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                data: _ctx.list,
                style: {"width":"100%"},
                "span-method": _ctx.arraySpanMethod
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "等级",
                    fixed: "",
                    width: "150"
                  }, {
                    default: _withCtx(({ row, $index }) => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("span", _hoisted_2, "VIP" + _toDisplayString($index + 1), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "会员名称*",
                    width: "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_ui_form_item, {
                        errorLayout: "flex",
                        style: {"margin":"0"},
                        required: true,
                        data: row.name
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: row.name,
                            "onUpdate:modelValue": ($event: any) => ((row.name) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "升级条件*",
                    width: "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_ui_form_item, {
                        errorLayout: "flex",
                        style: {"margin":"0"},
                        required: true,
                        data: row.score
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: row.score,
                            "onUpdate:modelValue": ($event: any) => ((row.score) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "会员权益",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, { label: "折扣" }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_ui_form_item, { style: {"margin":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: row.discount,
                                "onUpdate:modelValue": ($event: any) => ((row.discount) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { label: "多倍积分" }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_ui_form_item, { style: {"margin":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: row.rate,
                                "onUpdate:modelValue": ($event: any) => ((row.rate) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { label: "全场包邮" }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_checkbox, {
                            "true-label": 1,
                            "false-label": 0,
                            modelValue: row.freeDelivery,
                            "onUpdate:modelValue": ($event: any) => ((row.freeDelivery) = $event)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("包邮")
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { label: "活动" }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_ActiveityItem, {
                            modelValue: row.userVipActivityId,
                            "onUpdate:modelValue": ($event: any) => ((row.userVipActivityId) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    prop: "operat",
                    fixed: "right",
                    width: "150"
                  }, {
                    default: _withCtx(({ row, $index }) => [
                      ($index == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_el_button, {
                              onClick: _ctx.removeItem,
                              icon: "Delete"
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "span-method"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_link, {
                  onClick: _ctx.addVip,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加等级")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ]),
            _createVNode(_component_el_button, { onClick: _ctx.backEvent }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}